/* eslint-disable camelcase */
import React from 'react'
import { Card, Col, Row, Switch, Typography } from 'antd'
import moment from 'moment'
import PropTypes from 'prop-types'

import { LogoUploader } from '~components'
import { Checkbox, MultiSelect, MultiSelectDropdown, DatePicker, Label, Input, RichTextInput } from '~stories'

import { OPT_IN_TYPES, FLAG_APPS } from '../../constants'
import styles from './OptInInfo.module.css'

const { Title } = Typography

const OptInInfo = ({
  allEDPS,
  allPages,
  allVenues,
  handleAppNameChange,
  handleButtonTextUpdate,
  handleCalendarStatus,
  handleCoundDownEndDate,
  handleDescriptionChange,
  handleDisclaimerChange,
  handleFormIdUpdate,
  handleHeaderChange,
  handleImageUpload,
  handleMessageChange,
  handleOptInModalCountDownStatus,
  handleOptInTypeChange,
  handleTitleChange,
  handleVenueUpdate,
  optInModal,
  selectedEDPs,
  selectedPages,
  setAllEDPs,
  setAllPages,
  setSelectedEDPs,
  setSelectedPages
}) => {
  const {
    app_name = 'msg',
    type = 'default',
    button_text,
    enable_in_calendar,
    venue_id: venueId,
    count_down: {
      status,
      expiration_date_time
    },
    description,
    disclaimer,
    formstack_id,
    header,
    image_url,
    success_screen: {
      title,
      message
    }
  } = optInModal

  const manageLists = (items, source, dest, sourceFn, destFn) => {
    const selectedItems = Array.isArray(items)
      ? items
      : [items]
    const clonedSource = [...source]
    let clonedDest = [...dest]
    selectedItems.forEach(item => {
      const selectedEventIndex = clonedSource.findIndex(event => event.title === item.title)
      const [itemToMove] = clonedSource.splice(selectedEventIndex, 1)
      clonedDest = [...clonedDest, itemToMove]
    })
    sourceFn([...clonedSource])
    destFn([...clonedDest])
  }

  const onAdd = (selectedEvent, allPages, selectedPages, setAllPages, setSelectedPages) => {
    manageLists(selectedEvent, allPages, selectedPages, setAllPages, setSelectedPages)
  }

  const onRemove = (selectedEvent, allPages, selectedPages, setAllPages, setSelectedPages) => {
    manageLists(selectedEvent, selectedPages, allPages, setSelectedPages, setAllPages)
  }

  const onFilter = (allListItems, filterValue) => {
    const testRegExp = new RegExp(filterValue, 'i')
    return allListItems.filter(item => {
      const title = `${item?.title}`
      return testRegExp.test(title)
    })
  }

  const managePageLists = (items, source, dest, sourceFn, destFn) => {
    const selectedItems = Array.isArray(items)
      ? items
      : [items]
    const clonedSource = [...source]
    let clonedDest = [...dest]
    selectedItems.forEach(item => {
      const selectedEventIndex = clonedSource.findIndex(event => event.name === item.name)
      const [itemToMove] = clonedSource.splice(selectedEventIndex, 1)
      clonedDest = [...clonedDest, itemToMove]
    })
    sourceFn([...clonedSource])
    destFn([...clonedDest])
  }

  const onListAdd = (selectedEvent, allPages, selectedPages, setAllPages, setSelectedPages) => {
    managePageLists(selectedEvent, allPages, selectedPages, setAllPages, setSelectedPages)
  }

  const onListRemove = (selectedEvent, allPages, selectedPages, setAllPages, setSelectedPages) => {
    managePageLists(selectedEvent, selectedPages, allPages, setSelectedPages, setAllPages)
  }

  const onListFilter = (allListItems, filterValue) => {
    const testRegExp = new RegExp(filterValue, 'i')
    return allListItems.filter(item => {
      const name = `${item?.name}`
      return testRegExp.test(name)
    })
  }

  const expiryDate = expiration_date_time ? moment(expiration_date_time, 'X') : null
  const [venueName] = allVenues.filter(venue => venue.id === venueId)
  return (
    <>
      <Card>
        <Row gutter={8}>
          <Col span={16}>
            <Row>
              <Label
                isInline={false}
                value='App Name'
              /></Row>
            <Row>
              <MultiSelectDropdown
                allowClear={false}
                customStyle={{ width: 252 }}
                disabled
                displayField="name"
                dropdownOptions={FLAG_APPS}
                handleChange={handleAppNameChange}
                selectedItems={[app_name]}
                valueField="value"
              />
            </Row>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={16}>
            <Row>
              <Label
                isInline={false}
                value='Type'
              /></Row>
            <Row>
              <MultiSelectDropdown
                allowClear={false}
                customStyle={{ width: 252 }}
                displayField="name"
                dropdownOptions={OPT_IN_TYPES}
                handleChange={handleOptInTypeChange}
                selectedItems={[type]}
                valueField="value"
              />
            </Row>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={18}>
            <Label value={'Venue Name'} />
            <MultiSelectDropdown
              allowClear={false}
              customStyle={{ width: 450 }}
              displayField="name"
              dropdownOptions={allVenues}
              handleChange={selectedItems => handleVenueUpdate(selectedItems)}
              selectedItems={venueName?.name}
              valueField="name"
            />
          </Col>
        </Row>
        <Row gutter={8}>
          <Col span={5}>
            <Input label={'Formstack Id'}
              onChange={handleFormIdUpdate}
              value={formstack_id}
            />
          </Col>
        </Row>

        <Row gutter={8}>
          <Col span={8}>
            <Input label={'Submit Button Text'}
              onChange={handleButtonTextUpdate}
              value={button_text}
            />
          </Col>
        </Row>

        <RichTextInput label='Header' onChange={handleHeaderChange} value={header}/>
        <RichTextInput label='Description' onChange={handleDescriptionChange} value={description}/>
        <Row className={styles.logoContainer}>
          <LogoUploader handleUpload={handleImageUpload} logoUrl={image_url} />
        </Row>
        <RichTextInput label='Disclaimer' onChange={handleDisclaimerChange} value={disclaimer}/>
      </Card>< br/>
      <Card title="Success Screen">
        <RichTextInput label='Title' onChange={handleTitleChange} value={title}/>
        <RichTextInput label='Message' onChange={handleMessageChange} value={message}/>
      </Card>< br/>
      <Card title="Countdown">
        <Row>
          <Col span={3}>
            <Switch
              checked={status} checkedChildren="Show" defaultChecked onChange={handleOptInModalCountDownStatus} unCheckedChildren="Hide" />
          </Col>
        </Row>< br />< br />
        <Row>
          <Col span={8}>
            <DatePicker
              allowClear={true}
              format={'MM/DD/YYYY h:mm A'}
              label="Expiration Date: (ET)"
              onChange={handleCoundDownEndDate}
              showTime={true}
              value={expiryDate}
            />
          </Col>
        </Row>
      </Card>< br/>
      <Card extra={<Checkbox checked={enable_in_calendar} isInline label={<Title level={3}>Calendar</Title>} onChange={handleCalendarStatus}/>} title="Do not show Modal on">
        <Row>
          <Col span={14}>
            <MultiSelect
              availableListItems={allEDPS}
              displayField="title"
              onAdd={(items) => onAdd(items, allEDPS, selectedEDPs, setAllEDPs, setSelectedEDPs)}
              onFilter={onFilter}
              onRemove={(items) => onRemove(items, allEDPS, selectedEDPs, setAllEDPs, setSelectedEDPs)}
              resourceName="Events"
              selectedListItems={selectedEDPs}
              valueField='_id'
            />
          </Col>
        </Row>< br />< br />
        <Row>
          <Col span={14}>
            <MultiSelect
              availableListItems={allPages}
              displayField="name"
              onAdd={(items) => onListAdd(items, allPages, selectedPages, setAllPages, setSelectedPages)}
              onFilter={onListFilter}
              onRemove={(items) => onListRemove(items, allPages, selectedPages, setAllPages, setSelectedPages)}
              resourceName="Pages"
              selectedListItems={selectedPages}
              valueField='_id'
            />
          </Col>
        </Row>
      </Card>
    </>
  )
}

OptInInfo.propTypes = {
  allEDPS: PropTypes.array,
  allPages: PropTypes.array,
  allVenues: PropTypes.array,
  handleAppNameChange: PropTypes.func,
  handleButtonTextUpdate: PropTypes.func,
  handleCalendarStatus: PropTypes.func,
  handleCoundDownEndDate: PropTypes.func,
  handleDescriptionChange: PropTypes.func.isRequired,
  handleDisclaimerChange: PropTypes.func,
  handleFormIdUpdate: PropTypes.func,
  handleHeaderChange: PropTypes.func.isRequired,
  handleImageUpload: PropTypes.func,
  handleMessageChange: PropTypes.func,
  handleOptInModalCountDownStatus: PropTypes.func,
  handleOptInTypeChange: PropTypes.func,
  handleTitleChange: PropTypes.func,
  handleVenueUpdate: PropTypes.func,
  optInModal: PropTypes.object.isRequired,
  selectedEDPs: PropTypes.array,
  selectedPages: PropTypes.array,
  setAllEDPs: PropTypes.func,
  setAllPages: PropTypes.func,
  setSelectedEDPs: PropTypes.func,
  setSelectedPages: PropTypes.func
}

OptInInfo.defaultProps = {
  allVenues: [],
  optInModal: {}
}

export default OptInInfo
